import React, { useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

import { BUY, SELL } from '../../constants/pool.constants';
import { generatePointBackgroundColors } from '../../helpers';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

export function ExponentialDiagram({
  selectedOption,
  startPrice,
  delta,
  amount,
  slideValue,
}) {
  const [dataDiagram, setDataDiagram] = useState([]);
  const [labels, setLabels] = useState([]);

  useEffect(() => {
    setDataDiagram([]);
    function ExponentialCurveForBuy() {
      const newData = [];
      for (let i = 0; i <= amount - 1; i++) {
        let price = startPrice * Math.pow(1 - delta / 100, i);
        newData.push(price);
      }
      setDataDiagram(newData);
    }

    function ExponentialCurveForSell() {
      const newData = [];
      for (let i = 0; i <= amount - 1; i++) {
        let price = startPrice * Math.pow(1 + delta / 100, i);
        newData.push(price);
      }
      setDataDiagram(newData);
    }

    if (selectedOption === BUY) ExponentialCurveForBuy();

    if (selectedOption === SELL) ExponentialCurveForSell();
  }, [startPrice, delta, amount, setDataDiagram, selectedOption]);

  useEffect(() => {
    const newLabels = Array.from({ length: amount }, (_, i) =>
      (i + 1).toString()
    );
    setLabels(newLabels);
  }, [amount, setLabels]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: null,
      },
    },
    scales: {
      y: {
        ticks: { color: '#FFFFFF', beginAtZero: true },
        grid: {
          display: true,
          drawOnChartArea: true,
          drawTicks: true,
          color: '#8E8E8E',
        },
      },
      x: {
        ticks: { color: '#FFFFFF', beginAtZero: true },
        grid: {
          display: true,
          drawOnChartArea: true,
          drawTicks: true,
          color: '#2B282C',
        },
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        data: dataDiagram,
        borderColor: 'rgb(255,255,255)',
        backgroundColor: 'rgba(77,50,42,0.59)',
        pointBorderWidth: 7,
        pointBorderColor: generatePointBackgroundColors(amount, slideValue),
        pointBackgroundColor: '#E65634',
        fill: true,
        color: '#FFFFFF',
      },
    ],
  };

  return <Line width={927} height={241} options={options} data={data} />;
}
